export enum IssueGroupLabels {
  CrossTableChecks = 'Cross Table Checks',
  WithinTableChecks = 'Within Table Checks',
  ComparisonsToPreviousFPARTables = 'Comparisons to previous FPAR tables',
}
